import { LinkTarget } from '@atlassian/learning-components';
import { type NavigateFunction } from 'react-router-dom';

export const handleNavigate = (
  navigate: NavigateFunction,
  path: string,
  target: LinkTarget,
  isFullPathAvailable: boolean,
): void => {
  if (target === '_blank') {
    window.open(path, '_blank');
  } else if (isFullPathAvailable) {
    window.location.replace(path);
  } else {
    navigate(path);
  }
};
